import moment from 'moment';
import { put, takeEvery, call, select } from 'redux-saga/effects';
import { getTimezones } from 'api';
import { GET_TIMEZONES_REQUEST } from 'redux-api/action/actionTypes';
import * as actions from 'redux-api/action/timezones';
import { openFeedback } from 'redux-api/action/feedback';
import translations from 'translations';

const selectConfig = (state) => state.config;
const selectLastRefresh = (state) => state.timezones.lastRefresh;

function* getTimezonesSaga() {
  const { languageCode } = yield select(selectConfig);

  try {
    const now = moment();
    const lastRefresh = yield select(selectLastRefresh);
    const maxCachedTime = process.env.CACHED_TIME;

    if (lastRefresh) {
      const diff = now.diff(lastRefresh, 'minutes');

      if (diff < maxCachedTime) {
        return yield put(actions.getTimezonesCached());
      }
    }

    const { data } = yield call(getTimezones);

    return yield put(actions.getTimezonesSuccess(data));
  } catch (err) {
    yield put(
      openFeedback({
        message: translations[languageCode].generic_retrieve_api_error,
        error: err,
      }),
    );

    return yield put(actions.getTimezonesFailure(err));
  }
}

export default function* watchTimezones() {
  yield takeEvery(GET_TIMEZONES_REQUEST, getTimezonesSaga);
}
